import { Box, Card, CircularProgress, IconButton, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Icons } from '../../utils/utilities'
import { useQuizAndQuestionbankStore } from '../../store/quiz.store'
import { useStudyMaterialStore } from '../../store/studymaterial.store'
import { useDiscussionForum } from '../../store/discussionforum.store'
import { useUserStore } from '../../store/user.store'
import CountCard from '../common/CountCard'
import { useNavigate } from 'react-router-dom'

const FacultyResourceCountCards = () => {

    const [errors, setErrors] = useState( {
        quizzes: null,
        subjects: null,
        materials: null,
        discussions: null,
    } )
    const [counts, setCounts] = useState( {
        quizzes: null,
        subjects: null,
        materials: null,
        discussions: null,
    } )
    const [loadingDiscussions, setLoadingDiscussions] = useState( true )
    const [loadingMaterials, setLoadingMaterials] = useState( true )
    const [quizzesLoading, setQuizzesLoading] = useState( true )

    const QuizAndQuestionbankStore = useQuizAndQuestionbankStore()
    const StudyMaterialStore = useStudyMaterialStore()
    const DiscussionForumStore = useDiscussionForum()
    const UserStore = useUserStore()

    const navigate = useNavigate()

    const fetchQuizzes = useCallback( async () => {
        if ( QuizAndQuestionbankStore.getErrors.quizzes === true )
            await QuizAndQuestionbankStore.fetchQuizes()
        if ( QuizAndQuestionbankStore.getErrors.quizzes === true )
            setErrors( prev => {
                const newVal = { ...prev }
                newVal.quizzes = true
                return QuizAndQuestionbankStore.getErrors.quizzes === true
            } )
        else {
            setCounts( prev => {
                const newVal = { ...prev }
                newVal.quizzes = QuizAndQuestionbankStore.getQuizes?.length || 0
                return newVal
            } )
        }

        setQuizzesLoading( false )
    }, [QuizAndQuestionbankStore] )

    const fetchMaterials = useCallback( async () => {
        if ( StudyMaterialStore.getErrors.materials === true )
            await StudyMaterialStore.fetchMaterials()
        if ( StudyMaterialStore.getErrors.materials === true )
            setErrors( prev => {
                const newVal = { ...prev }
                newVal.materials = true
                return newVal
            } )
        else {
            setCounts( prev => {
                const newVal = { ...prev }
                newVal.materials = StudyMaterialStore.getMaterials["materials"]?.length
                return newVal
            } )
        }

        setLoadingMaterials( false )
    }, [StudyMaterialStore] )

    const getDiscussions = useCallback( async () => {
        setLoadingDiscussions( true )
        await DiscussionForumStore.fetchUserDiscussions()
        setCounts( prev => {
            const newVal = { ...prev }
            newVal.discussions = DiscussionForumStore.getDiscussions?.length
            return newVal
        } )
        setLoadingDiscussions( false )
    }, [DiscussionForumStore] )

    const setSubjectsCount = useCallback( () => {
        setCounts( prev => {
            const newVal = { ...prev }
            newVal.subjects = UserStore.getUserSubjectsDetails?.currentSubjects?.length || 0
            return newVal
        } )
    }, [UserStore] )

    useEffect( () => {
        fetchQuizzes()
        fetchMaterials()
        getDiscussions()
        setSubjectsCount()
    }, [fetchQuizzes, setSubjectsCount, getDiscussions, fetchMaterials] )

    return (
        <Box display="grid" gap="20px" width="100%" gridTemplateColumns={{ md: "repeat(4,1fr)", xs: "repeat(2,1fr)" }}>

            <CountCard onClick={() => navigate( `/faculty/quizzes` )} icon={Icons.default.QuizIcon} loading={quizzesLoading} label='Quizzes Counducted' value={counts.quizzes} />
            <CountCard onClick={() => navigate( `/faculty/material` )} icon={Icons.default.DescriptionIcon} loading={loadingMaterials} label="Materials" value={counts.materials} />
            <CountCard onClick={() => navigate( `/faculty/my-discussions` )} icon={Icons.default.Discussions} loading={loadingDiscussions} label="Discussions Hosted" value={counts.discussions} />
            <CountCard icon={Icons.default.Subjects} label="Current Subjects" value={counts.subjects} />

        </Box>
    )
}

export default FacultyResourceCountCards
